module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAYBAMAAAABjmA/AAAALVBMVEUAAAAAgf8AgP8Agf8AgP8AgP8Agf8AgP84TGE4TWI4TWI5SmA5VVUAgf85TWLnZyMWAAAADXRSTlMA0BDwYDCgn9KfYC0JekxUdwAAAFZJREFUCNdjSGKAgosBUMZdExjjbhGEIXsXKql2Fyo5xxkq+WIrVPLdK6jku3dgSRADIglkQCTBDHUgAy4FVQx0A0QC2UCIBBCAJFCdAZFAOBXheLh3AJuZR5YPOwuXAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./packages/theme-chalk/src/images/icon-title.png
// module id = 313
// module chunks = 0